import { Ref, forwardRef } from "react";
import nl2br from "react-nl2br";
import { twMerge } from "tailwind-merge";
import { Typography } from "../../Display";
import { Button } from "../../Inputs";
import { useDialogContext } from "../Dialog/Dialog.context";
import { Dialog } from "../Dialog/Dialog.page";
import { DialogRef } from "../Dialog/Dialog.types";
import { DialogAction } from "../Dialog/DialogAction.page";
import { DialogContent } from "../Dialog/DialogContent.page";
import { DialogTitle } from "../Dialog/DialogTitle.page";
import { Theme } from "./Alert.theme";
import { AlertContentProps, AlertProps } from "./Alert.types";

function AlertContent({
  cancelText,
  submitText,
  children,
  onSubmit,
  onCancel,
  payload,
  title,
  ...props
}: AlertContentProps) {

  const dialogContext = useDialogContext();

  const handleSubmit = () => {
    if (!props.mutation || !payload) {
      onSubmit?.(dialogContext.data);
    } else {
      props.mutation.mutate(payload);
    }
  };

  return (
    <>
      <DialogTitle title={title} />
      <DialogContent>
        {typeof (children) === "string" ? <Typography>{nl2br(children)}</Typography> : children}
      </DialogContent>
      {(cancelText || submitText) && (
        <DialogAction {...props}>
          <Button onClick={onCancel} className={twMerge(Theme.button, !cancelText && "hidden")}>
            {cancelText}
          </Button>
          <Button onClick={handleSubmit} className={twMerge(Theme.button, !submitText && "hidden")}>
            {submitText}
          </Button>
        </DialogAction>
      )}
    </>
  );
}

const Alert = forwardRef((
  {
    onSuccessGoBack,
    cancelText,
    submitText,
    mutation,
    children,
    onSubmit,
    onCancel,
    payload,
    loading,
    onHide,
    title,
    ...props
  }: AlertProps,
  ref: Ref<DialogRef>
) => {

  return (
    <Dialog
      closeOnBackdropClicked={true}
      size="xs"
      ref={ref}
      {...props}
    >
      <AlertContent
        {...{
          onSuccessGoBack,
          cancelText,
          submitText,
          mutation,
          children,
          onSubmit,
          onCancel,
          payload,
          loading,
          title
        }}
      />
    </Dialog>
  );
});

Alert.defaultProps = {
  cancelText: 'Cancel',
  submitText: 'OK'
} as AlertProps;

export { Alert };

